import styled from 'styled-components';

export const BackofficeBriefingsList = styled.div`
  font-family: Poppins, Heltica, Arial, sans-serif;
  padding: 30px 27px;
  Button, input, button, select, optgroup, textarea {
  	font-family: Poppins, Heltica, Arial, sans-serif;
  }
  header {
      font-size: 1.5em;
      margin-bottom: 20px;
  }
  .fa.fa-bullhorn {
    color: #F3463C;
    margin-right: 10px;
  }
  .table-list {
    background-color: #FFF;
    padding: 30px;
    
    .input-txt {
      font-size: 1.4em;
    }
    
    button.btn-backoffice-gearbox {
      border-radius: 12px;
      background-image: none;
      background-color: #FFF;
      padding-left: 15px;
      padding-right: 65px;
      
      svg.icon-caret-down {
        position: absolute;
        top: 0;
        right: 10px;
        bottom: 0;
        margin: auto;
      }
    }
    
    button.btn-clear-filters {
      border-radius: 12px;
      font-size: 1.4em;
      border: #CFCFCF solid 1px;
      color: #B2B2B2;
    }
    
    .selectOrder select {
      border-radius: 12px;
      background-image: none;
      background-color: #FFF;
      padding-left: 15px;
    }
  }
  
  h3 {
    color: #2B2932;
    font-size: 1.5em;
  }
  
  table {
    font-size: 10px;
    color: #707070;
    
    th {
      font-size: 1.2em;
    }
  
    tbody {
      font-size: 1.4em;
    }
    
    button.btn-secondary {
      background-color: #707070;
      color: #FFFFFF;
    }
  }
`;
